import { Analytics } from 'packages';
import cookieUtil from 'tradera-utils/cookie';
import { setPreferredCurrency } from './reducer';
import { selectIsLoggedIn } from 'tradera-state/member/selectors';
import { touchWebClient } from 'tradera-utils/http';
import { selectPreferredLanguage } from 'tradera-state/language/selectors';

export const setPreferredCurrencyThunk = currencyCode => async (
    dispatch,
    getState
) => {
    Analytics.trackEvent({
        category: 'Settings',
        action: 'Currency',
        label: currencyCode
    });

    if (selectIsLoggedIn(getState())) {
        await touchWebClient.post('my/profile/save-currency-setting', {
            currencyCode
        });
    }

    createPreferredCurrencyCookie(currencyCode);
    dispatch(setPreferredCurrency({ currencyCode }));
};

export const setCurrencyIfNotChosen = currencyCode => (dispatch, getState) => {
    if (
        cookieUtil.readCookie('preferred_currency') ||
        selectIsLoggedIn(getState())
    ) {
        return;
    }

    const { languageCodeIso2 } = selectPreferredLanguage(getState());

    const map = {
        sv: 'SEK',
        da: 'DKK',
        de: 'EUR'
    };

    if (Object.keys(map).includes(languageCodeIso2)) {
        dispatch(setPreferredCurrencyThunk(map[languageCodeIso2]));
    } else {
        dispatch(setPreferredCurrencyThunk(currencyCode));
    }
};

const yearInMilliseconds = 1000 * 60 * 60 * 24 * 365;
const createPreferredCurrencyCookie = currencyCode => {
    cookieUtil.createCookie(
        'preferred_currency',
        currencyCode,
        new Date(new Date().getTime() + yearInMilliseconds)
    );
};
